export default __webpack_public_path__ + "1.17.16/static/media/no-practices.8a6fd274.svg";